import { RevenueDealStatusFilter, RevenuePaymentTypeFilter } from '@trnsact/trnsact-shared-types';
import { SelectOption } from '../../../global';
import { FinanceDateRange } from '../performance/types';

export enum FinanceFilterType {
  DEAL_DATE = 'DEAL_DATE',
  SALES_REP = 'SALES_REP',
  LOCATION = 'LOCATION',
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  DEAL_STATUS = 'DEAL_STATUS',
}

export type FinanceFilters = {
  [FinanceFilterType.DEAL_DATE]: FinanceDateRange;
  [FinanceFilterType.SALES_REP]: SelectOption[];
  [FinanceFilterType.LOCATION]: SelectOption[];
  [FinanceFilterType.PAYMENT_TYPE]: RevenuePaymentTypeFilter;
  [FinanceFilterType.DEAL_STATUS]: RevenueDealStatusFilter | 'ALL';
};

export interface FinanceFilterCardProps {
  meta?: Partial<Record<FinanceFilterType, SelectOption[]>>;
}

export type FinanceFiltersPayload = {
  dealDate?: {
    from: string;
    to: string | null;
  };
  salesRep?: (string | null)[];
  location?: (string | null)[];
  paymentType?: RevenuePaymentTypeFilter;
  dealStatus?: RevenueDealStatusFilter;
};
